import React, { useState } from "react";
import axios from "axios";
import { useLocation, Link, useNavigate } from "react-router-dom";
import "./login.css";
import { getNodeApiBase } from "../utils/apiBase";

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const nodeApiBase = getNodeApiBase();

  // Extract token from URL
  const params = new URLSearchParams(location.search);
  const token = params.get("token");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");
    if (!password || !confirmPassword) {
      setError("Veuillez remplir tous les champs.");
      return;
    }
    if (password !== confirmPassword) {
      setError("Les mots de passe ne correspondent pas.");
      return;
    }
    setLoading(true);
    try {
      const response = await axios.post(`${nodeApiBase}/api/reset-password`, {
        token,
        password,
      });
      if (response.data.success) {
        setMessage("Votre mot de passe a été réinitialisé avec succès.");
        setLoading(false);
        navigate("/login", { state: { passwordResetSuccess: true } });
        return;
      } else {
        setError(response.data.message || "Erreur lors de la réinitialisation.");
      }
    } catch (err) {
      setError("Erreur lors de la réinitialisation. Veuillez réessayer.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-content">
          <form onSubmit={handleSubmit}>
            <p>Définir un nouveau mot de passe</p>
            <div className="input-container">
              <label htmlFor="password">Nouveau mot de passe</label>
              <input
                name="password"
                type="password"
                placeholder="Nouveau mot de passe"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={loading}
              />
            </div>
            <div className="input-container">
              <label htmlFor="confirmPassword">Confirmer le mot de passe</label>
              <input
                name="confirmPassword"
                type="password"
                placeholder="Confirmer le mot de passe"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                disabled={loading}
              />
            </div>
            <div className="button-container">
              <button type="submit" disabled={loading}>
                {loading ? "Envoi..." : "Réinitialiser"}
              </button>
            </div>
            {message && <div className="success-message">{message}</div>}
            {error && <div className="error-message">{error}</div>}
          </form>
        </div>
        <div className="account-link">
          <Link to="/login">
            <span>Retour à la connexion</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
